export default {
    getEvents() {
        return axios.get('/api/roster/events');
    },
    getRosterByCurrentUser(eventId, rosterDate) {
        return axios.post('/api/roster/eventroster', { 'event': eventId, 'roster': rosterDate});
    },
};
